<template>
  <b-modal
    id="pos-send-invoice-modal"
    :title="title"
    :ok-title="trans('send')"
    :ok-disabled="busy || !canSend"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onSend"
  >
    <b-form-group :label="trans('email')">
      <b-form-input type="email" name="email" v-model="email" :state="emailState" :disabled="busy" />
    </b-form-group>
    <p>{{ trans('or') }}...</p>
    <b-form-group :label="trans('mobile')">
      <b-form-input name="mobile" v-model="mobile" :state="mobilState" :disabled="busy" />
    </b-form-group>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      invoice: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        email: null,
        mobile: null,
      }
    },
    computed: {
      title() {
        let title = trans('send_invoice')
        if (!!this.invoice) {
          title += ` #${this.invoice.invoice_no}`
        }
        return title
      },
      emailState() {
        if (!this.email || !this.email.trim()) return null
        return _.validateEmail(this.email)
      },
      mobilState() {
        if (!this.mobile || !this.mobile.trim()) return null
        return _.validatePhone(this.mobile)
      },
      serialized() {
        let o = {}
        if (this.emailState === true) o.email = this.email
        if (this.mobilState === true) o.mobile = this.mobile
        return o
      },
      canSend() {
        return !_.isEmpty(this.serialized) &&
          this.emailState !== false && this.mobilState !== false
      },
    },
    methods: {
      onHidden() {
        this.busy = false
        this.error = null
        this.email = null
        this.mobile = null
      },
      onShown() {
        if (!this.invoice.is_no_client) {
          this.email = this.invoice.recipient.email
        }
      },
      onSend(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/invoice/no/${this.invoice.invoice_no}/send`
        axios.post(url, this.serialized)
        .then(response => {
          this.busy = false
          _.toastSuccess(this, response.data.message)
          this.$bvModal.hide('pos-send-invoice-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.posSendInvoiceModal = this
    },
  }
</script>